import { render, staticRenderFns } from "./arrivals-section.vue?vue&type=template&id=74c94330&"
import script from "./arrivals-section.vue?vue&type=script&lang=js&"
export * from "./arrivals-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports